import React from 'react'
import { observer } from 'mobx-react-lite'
import ContentHtml from '../../../components/content/ContentHtml/ContentHtml.component'
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBRow } from 'mdb-react-ui-kit'

const formatNumber = (points, pos) => {
  points = `${parseFloat(points)}`.split('.')
  let remainder = points.length === 1 ? '000' : points.pop().substr(0, 3)

  for (let i = pos - `${remainder}`.length; i > 0; i--) remainder += '0'

  return [points, remainder].join('.')
}

const SpecialtyPoints = ({ overrides, coverages, carriers, uniques, isLoading }) => {
  overrides = Array.isArray(overrides) ? overrides : []
  const groups = {}

  const getCarrier = carrierId => {
    const fld = 'c_name'
    let name =
      carrierId && Array.isArray(carriers)
        ? carriers.filter(carrier => parseInt(carrier.id) === parseInt(carrierId)).shift()?.[fld]
        : null
    return name ? name : null
  }

  const getCoverage = coverageId => {
    const fld = 'coverage_name'
    let name = coverageId
      ? Array.isArray(coverages)
        ? coverages.filter(coverage => parseInt(coverage.id) === parseInt(coverageId)).shift()?.[fld]
        : null
      : null
    return name ? name : null
  }

  const getField = field => {
    switch (field) {
      case 'ac_family':
        return 'Family Selection'
      default:
        return ''
    }
  }

  const renderGroupName = group => {
    if (group.includes('||')) {
      const parts = group.split('||')
      return (
        <>
          {parts[0]}
          <br />
          {parts[1]}
        </>
      )
    }
    return group
  }

  const renderUniquesTable = () => {
    return (
      <table className='points-uniques-payout'>
        <thead>
          <tr>
            <th>Carrier:</th>
            <th>Market:</th>
            <th>Coverage:</th>
            <th>Point Factor:</th>
            <th>Fixed Points:</th>
          </tr>
        </thead>
        <tbody>
          {uniques.map((unique, idx1) => {
            return unique.points.map((pts, idx2) => {
              return (
                <tr key={`carrier-unique-points-${idx1}-${idx2}-${unique.id}`}>
                  <td>{unique.c_name}</td>
                  <td>{pts.coverage_category}</td>
                  <td>{pts.coverage_name}</td>
                  <td>{formatNumber(parseFloat(pts.factor1) * parseInt(pts.factor2), 3)}</td>
                  <td>{pts.setpoints || '-'}</td>
                </tr>
              )
            })
          })}
        </tbody>
      </table>
    )
  }

  overrides.forEach(override => {
    const carrierName = getCarrier(override?.carrier_id)
    const coverageName = getCoverage(override?.coverage_id)

    let name
    if (carrierName && coverageName) {
      name = `Carrier: ${carrierName}||Coverage: ${coverageName}`
    } else if (carrierName) {
      name = `Carrier: ${carrierName}`
    } else if (coverageName) {
      name = `Coverage: ${coverageName}`
    }

    if (!groups.hasOwnProperty(name)) groups[name] = []

    groups[name].push(override)
  })

  const recordsExist = (overrides && overrides.length) || (uniques && uniques.length)

  if (!recordsExist) return <></>

  return (
    <MDBCard id='SpecialtyPointsComponent' className='card-cascade narrower points-component'>
      <MDBCardBody>
        <MDBCardTitle>Specialty Points Assignments</MDBCardTitle>
        <MDBRow>
          <MDBCol size='12'>
            <ContentHtml contentSlug='av-points-overrides-detail' />
          </MDBCol>
        </MDBRow>
        {uniques && uniques.length ? (
          <MDBRow>
            <MDBCol size='12'>{renderUniquesTable()}</MDBCol>
          </MDBRow>
        ) : (
          <></>
        )}
        {overrides && overrides.length ? (
          <MDBRow>
            <MDBCol size='12'>
              <table className='points-overrides'>
                <thead>
                  <tr>
                    <th>Carrier / Coverage:</th>
                    <th>Field:</th>
                    <th>Option:</th>
                    <th>Points:</th>
                  </tr>
                </thead>
                {Object.keys(groups)
                  .sort((a, b) => {
                    const aIsCarrier = a.startsWith('Carrier:')
                    const bIsCarrier = b.startsWith('Carrier:')
                    if (aIsCarrier && !bIsCarrier) return -1
                    if (!aIsCarrier && bIsCarrier) return 1
                    return a.localeCompare(b)
                  })
                  .map((group, idx) => {
                    let rows = groups[group].length,
                      row1 = groups[group].shift()

                    return (
                      <tbody key={`pts-detail-group-${group}-${idx}`}>
                        <tr>
                          <td rowSpan={rows}>
                            <strong>{renderGroupName(group)}</strong>
                          </td>
                          <td rowSpan={rows}>
                            <i>{getField(row1?.field)}</i>
                          </td>
                          <td>{row1?.label}</td>
                          <td>{row1?.points}</td>
                        </tr>
                        {groups[group].map((item, idx) => {
                          return (
                            <tr key={`pts-item-${item?.label}-${item?.id}-${idx}`}>
                              <td>{item?.label}</td>
                              <td>{item?.points}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    )
                  })}
              </table>
            </MDBCol>
          </MDBRow>
        ) : (
          <></>
        )}
      </MDBCardBody>
    </MDBCard>
  )
}

export default observer(SpecialtyPoints)
